export const CURRENCIES = {
  "USD": {
    "symbol": "$",
    "name": "US Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "USD",
    "name_plural": "US dollars"
  },
  "CAD": {
    "symbol": "CA$",
    "name": "Canadian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CAD",
    "name_plural": "Canadian dollars"
  },
  "EUR": {
    "symbol": "€",
    "name": "Euro",
    "symbol_native": "€",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EUR",
    "name_plural": "euros"
  },
  "BRL": {
    "symbol": "R$",
    "name": "Brazilian Real",
    "symbol_native": "R$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BRL",
    "name_plural": "Brazilian reals"
  },
  "ARS": {
    "symbol": "AR$",
    "name": "Argentine Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ARS",
    "name_plural": "Argentine pesos"
  },
  "AUD": {
    "symbol": "AU$",
    "name": "Australian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AUD",
    "name_plural": "Australian dollars"
  },
  "GBP": {
    "symbol": "£",
    "name": "British Pound Sterling",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GBP",
    "name_plural": "British pounds sterling"
  },
  "JPY": {
    "symbol": "¥",
    "name": "Japanese Yen",
    "symbol_native": "￥",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "JPY",
    "name_plural": "Japanese yen"
  },
  "CNY": {
    "symbol": "CN¥",
    "name": "Chinese Yuan",
    "symbol_native": "CN¥",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CNY",
    "name_plural": "Chinese yuan"
  },
  "MXN": {
    "symbol": "MX$",
    "name": "Mexican Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MXN",
    "name_plural": "Mexican pesos"
  },
  "CLP": {
    "symbol": "CL$",
    "name": "Chilean Peso",
    "symbol_native": "$",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "CLP",
    "name_plural": "Chilean pesos"
  },
  "COP": {
    "symbol": "CO$",
    "name": "Colombian Peso",
    "symbol_native": "$",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "COP",
    "name_plural": "Colombian pesos"
  },
  "PEN": {
    "symbol": "S/.",
    "name": "Peruvian Nuevo Sol",
    "symbol_native": "S/.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PEN",
    "name_plural": "Peruvian nuevos soles"
  },
  "UYU": {
    "symbol": "$U",
    "name": "Uruguayan Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UYU",
    "name_plural": "Uruguayan pesos"
  },
  "VEF": {
    "symbol": "Bs.F.",
    "name": "Venezuelan Bolívar",
    "symbol_native": "Bs.F.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "VEF",
    "name_plural": "Venezuelan bolívars"
  }
};

export const DATE_FORMATS = {
  "DD/MM/YYYY": {
    "format": "DD/MM/YYYY",
    "name": "DD/MM/YYYY",
    "example": "25/12/2023"
  },
  "MM/DD/YYYY": {
    "format": "MM/DD/YYYY", 
    "name": "MM/DD/YYYY",
    "example": "12/25/2023"
  },
  "YYYY-MM-DD": {
    "format": "YYYY-MM-DD",
    "name": "YYYY-MM-DD",
    "example": "2023-12-25"
  },
  "DD-MM-YYYY": {
    "format": "DD-MM-YYYY",
    "name": "DD-MM-YYYY", 
    "example": "25-12-2023"
  },
  "MM-DD-YYYY": {
    "format": "MM-DD-YYYY",
    "name": "MM-DD-YYYY",
    "example": "12-25-2023"
  },
  "DD.MM.YYYY": {
    "format": "DD.MM.YYYY",
    "name": "DD.MM.YYYY",
    "example": "25.12.2023"
  },
  "MM.DD.YYYY": {
    "format": "MM.DD.YYYY", 
    "name": "MM.DD.YYYY",
    "example": "12.25.2023"
  }
};

// Função para formatar valores monetários
export const formatCurrency = (amount, currencyCode = 'BRL', showSymbol = true) => {
  const currency = CURRENCIES[currencyCode] || CURRENCIES.BRL;
  const numericAmount = parseFloat(amount) || 0;
  
  const formatted = numericAmount.toLocaleString('pt-BR', {
    minimumFractionDigits: currency.decimal_digits,
    maximumFractionDigits: currency.decimal_digits
  });
  
  return showSymbol ? `${currency.symbol_native} ${formatted}` : formatted;
};

// Função para obter lista de currencies para select
export const getCurrencyOptions = () => {
  return Object.keys(CURRENCIES).map(code => ({
    value: code,
    label: `${CURRENCIES[code].name} (${CURRENCIES[code].symbol_native})`,
    code: code,
    currency: CURRENCIES[code]
  }));
};

// Função para obter lista de formatos de data para select  
export const getDateFormatOptions = () => {
  return Object.keys(DATE_FORMATS).map(format => ({
    value: format,
    label: `${DATE_FORMATS[format].name} - ${DATE_FORMATS[format].example}`,
    format: DATE_FORMATS[format]
  }));
};